import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { BcacSelectComponent } from './bcac-select.component';


@NgModule({
  declarations: [BcacSelectComponent],
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    NzToolTipModule
  ],
  exports: [BcacSelectComponent]
})
export class BcacSelectModule { }
